import React, { Component } from 'react';

class Truckers extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="full-div">
                <div className="hero-min">
                    <div className="spacer"></div>
                    <div className="hero-min-topic">
                        <h2>Trucker Information</h2>
                        <p>
                            Sign up with Towva today and start earning more on your own schedule!
                        </p>
                    </div>
                </div>
                <div className="container bottom-pad">
                    <div className="info-grid">
                        <div className="" data-aos="fade-left">
                            <div className="user-info-img">
                                <img src={require("./../images/increase-profit.jpg")} width="100%" alt=""/>
                            </div>
                        </div>
                        <div className="info-grid-text" data-aos="fade-right">
                            <div>
                                <br/>
                                <h4>Increased profit margin</h4>
                                <p>
                                    The Towva app structure is such that there is a fixed base amount for every trip. This amount increases according to the time spent and the distance covered during the trip. This way, even with delays and unforeseen circumstances, service providers never end up on the losing side.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row cent">
                        <div className="col-md-6" data-aos="fade-up">
                            <div className="why-img">
                                <img src={require("./../images/choose-shedule.png")} width="100%" alt=""/>
                            </div>
                            <h4>Choose your schedule</h4>
                            <p>
                                With Towva, you can choose your own hours, day or night, a few hours or round the clock, it’s up to you. By doing this, you can always make time for yourself.
                            </p>
                        </div>
                        <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                            <div className="why-img">
                                <img src={require("./../images/help-icon.png")} width="100%" alt=""/>
                            </div>
                            <h4>All the help you need</h4>
                            <p>
                                Once you pick up a fare, Towva provides you with precise directions, communication with the client, as well as round-the-clock support, just in case. Towva always has you covered!
                            </p>
                        </div>
                    </div>
                </div>
                <div className="blue-sect">
                    <div className="container-personal">
                        <div className="about-user">
                            <h2>About the app</h2>
                        </div>
                        <div className="row">
                            <div className="col-md-6" data-aos="zoom-in" data-aos-delay="200">
                                <div className="about-img">
                                    <img src={require("./../images/phone-app.png")} width="100%" alt=""/>
                                </div>
                            </div>
                            <div className="col-md-6" data-aos="fade-up">
                                <div className="about-user-info">
                                    <p>
                                        <span>Custom Designed for Drivers</span> <br/><br/>
                                        Towva has made everything super simple for towing service providers. When you want to work on the app, just open it and wait for the trip 
                                        requests to come in. Once you’ve accepted a trip, you get a detailed description of the ride, including directions to their location and their destination. You can pick up rides as many times as you want in a day- You’re the boss!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         );
    }
    componentDidMount(){
        window.scrollTo(0, 0)
    }
}
 
export default Truckers;